import TextField from '@material-ui/core/TextField';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import DatePicker from '@material-ui/lab/DatePicker';
import PropTypes from 'prop-types';
import { FC } from 'react';

interface BasicDatePickerProps{
  label: string;
  index: string;
  selectedDate: Date;
  minDate?: Date;
  maxDate?: Date;
  onSelect: (event: any) => void;
  maxWidth?: number;
  minWidth?: number | string;
  margin?: number;
}
export const BasicDatePicker: FC<BasicDatePickerProps> = (props) => {
  const { label, index, selectedDate, minDate,
    maxDate, onSelect, maxWidth, minWidth, margin } = props;

  const markReadOnly = (e) => {
    if (!e.target.readOnly) {
      e.target.readOnly = true;
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label={label}
        inputFormat="dd/MM/yyyy"
        openTo="day"
        views={['year', 'month', 'day']}
        minDate={minDate}
        maxDate={maxDate}
        value={(selectedDate && selectedDate.toString() !== 'Invalid Date') ? selectedDate : null}
        onChange={(selectedValue) => onSelect({
          index,
          selectedValue,
          label
        })}
        renderInput={(params) => (
          <TextField
            onClick={(e) => { markReadOnly(e); }}
            onFocus={(e) => { markReadOnly(e); }}
            size="small"
            sx={{
              m: margin || 1,
              maxWidth: maxWidth || '100%',
              minWidth: minWidth || '100%'
            }}
            {...params}
          />
        )}
      />
    </LocalizationProvider>
  );
};

BasicDatePicker.defaultProps = {
  minDate: undefined,
  maxDate: undefined
};

BasicDatePicker.propTypes = {
  label: PropTypes.string,
  index: PropTypes.string,
  selectedDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  onSelect: PropTypes.func,
  maxWidth: PropTypes.number,
  minWidth: PropTypes.number || PropTypes.string,
  margin: PropTypes.number
};
